export enum ACTION_TYPES {
  CLEAR_POST_PRODUCT_SELECT_ERROR = 'CLEAR_POST_PRODUCT_SELECT_ERROR',
  FETCH_POST_PRODUCT_SELECT = 'FETCH_POST_PRODUCT_SELECT',
  FETCH_POST_PRODUCT_SELECT_FAIL = 'FETCH_POST_PRODUCT_SELECT_FAIL',
  FETCH_POST_PRODUCT_SELECT_SUCCESS = 'FETCH_POST_PRODUCT_SELECT_SUCCESS',
}
